import { useState } from 'react';
import {
  OnboardingStore,
  OnboardingStoreType
} from '@blisspointmedia/bpm-types/dist/ClientOracleOnboarding';
import { useExperimentFlag } from '@src/utils/experiment-context';

interface OnboardingStoreState {
  store: OnboardingStoreType;
  setStore: (store: OnboardingStoreType) => void;
  canOverride: boolean;
}

// Every user starts on `tinuiti`. Users in the experiment see the toggle and can switch to
// `assemble` for this session; the backend validates `store` on every request either way.
export const useOnboardingStore = (): OnboardingStoreState => {
  const canOverride = Boolean(useExperimentFlag('enableOracleClientConfigUsingAssemble'));
  const [store, setStore] = useState<OnboardingStoreType>(OnboardingStore.TINUITI);

  return { store, setStore, canOverride };
};
